var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_4924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35718 6.56309H6.35718V4.35718H5.35718V6.56309ZM5.85718 0.857178C3.09468 0.857178 0.857178 3.09468 0.857178 5.85718C0.857178 8.61968 3.09468 10.8572 5.85718 10.8572C8.61968 10.8572 10.8572 8.61968 10.8572 5.85718C10.8572 3.09468 8.61968 0.857178 5.85718 0.857178ZM5.85718 9.85718C3.65218 9.85718 1.85718 8.06218 1.85718 5.85718C1.85718 3.65218 3.65218 1.85718 5.85718 1.85718C8.06218 1.85718 9.85718 3.65218 9.85718 5.85718C9.85718 8.06218 8.06218 9.85718 5.85718 9.85718ZM5.35718 4.35718H6.35718V3.35718H5.35718V4.35718Z",
    fill: "#D70303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.50635,
    y: 7.27148,
    width: 0.988235,
    height: 0.917648,
    fill: "#FF2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_4924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.0662d79d0a27d2af50a90d51f9c1e129.svg";
export { ForwardRef as ReactComponent };